import React from 'react';

import NewQuoteItemForm from "../../../Modals/ShadeModals/AddShade/NewQuoteItem";
import NewAccessoryForm from "./Accessories/NewAccessoryForm";
import DescriptionSlides from '../../DescriptionSlides';
import { NewFabricForm } from './NewFabricSampleForm';
import NewAwningForm from './NewAwningForm';

import PartsForm from '../../PartsForm';
import { useQuoteFabricSamplesByQuoteId } from '../../../Store/entities/fabricSamples/hooks';
import { UsePortalDispatch } from '../../../Store';
import { addQuoteFabricSample, updateQuoteFabricSample } from '../../../Store/entities/fabricSamples';
import { useQuoteById, useQuoteTypeNameByQuoteId } from '../../../Store/entities/quotes/hooks';
import { useIsPowerShadesAdmin } from '../../../hooks';

type ProductFormProps = {
	quoteId: number;
	quoteType: string;
	onCancel: () => void;
	onAdd: () => void;
	close: () => void;
	openAddPsOutdoorShade: () => void;
	indoorFabrics: any;
	outdoorFabrics: any;
};

const ProductForm = ({
	indoorFabrics,
	outdoorFabrics,
	// quote,
	onCancel,
	// onAdd,
	close,
	// openAddPsOutdoorShade,
	quoteId
}: ProductFormProps) => {
	const quote = useQuoteById(quoteId);
	const productCategory = quote?.product_category ?? 'roller_shades';
	const isAwningQuote = productCategory === 'awnings';
	const isRollerShadeQuote = !isAwningQuote;

	const [focusedOption] = React.useState<any>(null);
	const [tab, setTab] = React.useState(isAwningQuote ? "Awnings" : "Shades");
	const [showRequired] = React.useState(false);
	const quoteSamples = useQuoteFabricSamplesByQuoteId(quoteId);
	const dispatch = UsePortalDispatch();
	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	React.useEffect(() => {
		if (isAwningQuote) {
			setTab("Awnings");
		} else if (isRollerShadeQuote) {
			setTab((current) => (current === "Awnings" ? "Shades" : current));
		}
	}, [isAwningQuote, isRollerShadeQuote]);

	const setFabSampleQuantity = (fabricName: string, quantity: number) => {

		if (quoteSamples.some((sample) => sample.Name === fabricName)) {
			dispatch(updateQuoteFabricSample({
				quoteId,
				quantity,
				name: fabricName
			}));
		} else {
			dispatch(addQuoteFabricSample({
				quoteId,
				quantity,
				name: fabricName
			}));
		}
	};
	const contents: {
		title: string;
		content: React.ReactNode;
	}[] = [];

	if (!isAwningQuote) {
		contents.push({
			title: 'Shades',
			content: <NewQuoteItemForm
				quoteId={quoteId}
				onCancel={onCancel}
			/>
		});
	}
	
	if (!isRollerShadeQuote) {
		contents.push({
			title: 'Awnings',
			content: <NewAwningForm
				quoteId={quoteId}
				quoteType={quoteType}
				onCancel={onCancel}
			/>
		});
	}

	if (!isAwningQuote) {
		contents.push({
			title: 'Accessories',
			content: <NewAccessoryForm
				quoteId={quoteId}
				onDone={close}
			/>
		});

		contents.push({
			title: 'Samples',
			content: <NewFabricForm
				quoteType={quoteType}
				invoiceTable={false}
				quoteSamples={quoteSamples}
				isManuacturer // cSpell:disable-line
				onDone={close}
				onChange={setFabSampleQuantity}
				indoorFabrics={indoorFabrics}
				outdoorFabrics={outdoorFabrics}
			/>
		});
	}

	const isPsAdmin = useIsPowerShadesAdmin();
	const showParts = isPsAdmin && !isAwningQuote;

	if (showParts) {
		contents.push({
			title: 'Parts',
			content: <PartsForm
				onDone={close}
				quoteId={quoteId}
				quoteType={quoteType}
			/>,
		});
	}
	const currentContent = contents.find((content) => content.title === tab)?.content;

	return (

		<>

			<div className={`option-description ${focusedOption && DescriptionSlides[focusedOption.varName] ? 'show' : ''}`}>
				{
					focusedOption && DescriptionSlides[focusedOption.varName]
						? DescriptionSlides[focusedOption.varName](focusedOption)
						: null
				}
			</div>

			<div className={`product-form ${showRequired ? 'show-required' : ''} showing-description-modal`}>

				<div className="mode-toggle">

					{
						contents.map((content, index) => (
							<div
								key={index}
								className={tab === content.title ? `active ${quoteType}` : 'border border-secondary-subtle'}
								onClick={() => setTab(content.title)}
							>
								{content.title}
							</div>
						))
					}
				</div>

				{currentContent}




			</div>
		</>
	);
};

export default ProductForm;
